import {organizationOnlineGuard} from "@/guards/organizationOnlineGuard";

export const appHostOrOnlineOrganizationGuard = (to, from, next) => {
    const appUrl = new URL(window.appConfig.PUBLIC_URL).hostname;
    const currentDomain = window.location.hostname;

    if (currentDomain !== appUrl) {
        organizationOnlineGuard(to, from, next);
    } else {
        next();
    }
};
